import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CopyConnectorConfigEnvButtonComponent, SharedModule } from '@blaze-shared/shared-feature';
import { DialogComponent, PanelComponent } from '@blaze-shared/shared-ui';

import { ApiActionCardComponent } from './api-action-card/api-action-card.component';
import { ApiBuilderComponent } from './api-builder/api-builder.component';
import { ApiBuilderPageComponent } from './api-builder-page/api-builder-page.component';
import { ApiGeneralCardComponent } from './api-general-card/api-general-card.component';
import { AssignParametersTestValuesDialogComponent } from './assign-parameters-test-values-dialog/assign-parameters-test-values-dialog.component';
import { BodyEditorDialogComponent } from './body-editor-dialog/body-editor-dialog.component';
import { BodyParameterEditDialogComponent } from './body-parameter-edit-dialog/body-parameter-edit-dialog.component';
import { OauthAuthorizationFormComponent } from './oauth-authorization-form/oauth-authorization-form.component';
import { ParametersListComponent } from './parameters-list/parameters-list.component';
import { ParametersListExtendedComponent } from './parameters-list-extended/parameters-list-extended.component';
import { RestApiConnectorDialogComponent } from './rest-api-connector-dialog/rest-api-connector-dialog.component';
import { ResultPathSelectDialogComponent } from './result-path-select-dialog/result-path-select-dialog.component';
import { TestActionBtnComponent } from './test-action-btn/test-action-btn.component';
import { TypedValueInputFieldComponent } from './typed-value-input-field/typed-value-input-field.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    OverlayModule,
    // components
    ApiActionCardComponent,
    ApiBuilderComponent,
    ApiBuilderPageComponent,
    ApiGeneralCardComponent,
    AssignParametersTestValuesDialogComponent,
    BodyEditorDialogComponent,
    BodyParameterEditDialogComponent,
    CopyConnectorConfigEnvButtonComponent,
    DialogComponent,
    OauthAuthorizationFormComponent,
    PanelComponent,
    ParametersListComponent,
    ParametersListExtendedComponent,
    RestApiConnectorDialogComponent,
    ResultPathSelectDialogComponent,
    TestActionBtnComponent,
    TypedValueInputFieldComponent,
  ],
})
export class ApiBuilderModule {}
